export default __webpack_public_path__ + "static/media/thumb-MDS-5.bf3a0972.png";